'use client';

import { useEffect } from 'react';
import { useStore } from '@/store/store';
import { classes } from '@/utils/classes/classes';
import './styles/default.scss';

type Props = {
    children: React.ReactNode;
};

export const LobbyBackgroundLock = ({ children }: Props) => {
    const isEmbeddedGameOpen = useStore((state) => state.embeddedGame.isOpen);

    useEffect(() => {
        if (!isEmbeddedGameOpen) {
            return undefined;
        }

        const { documentElement } = document;
        const previousOverflow = documentElement.style.overflow;

        documentElement.style.overflow = 'hidden';

        return () => {
            documentElement.style.overflow = previousOverflow;
        };
    }, [isEmbeddedGameOpen]);

    return (
        <div
            className={classes(isEmbeddedGameOpen && 'lobby-background-lock')}
            aria-hidden={isEmbeddedGameOpen ? true : undefined}
            inert={isEmbeddedGameOpen ? true : undefined}>
            {children}
        </div>
    );
};
